document.querySelector('.toggle').addEventListener('click',event => {
	event.stopPropagation()
	document.querySelector('nav').classList.toggle('open')
})

document.body.addEventListener('click',event => {
	if (!event.target.closest('nav')) document.querySelector('nav').classList.remove('open')
})

document.querySelector('.close').addEventListener('click',() => {
	document.querySelector('nav').classList.remove('open')
})